import { useActionState, useEffect } from "react";
import Logo from "../components/login/Logo";
import SpaceBackground from "../components/login/SpaceBackground";
import Start from "../components/login/Start";

import { AnimatePresence, motion } from "motion/react";
import LoginEmail from "../components/login/LoginEmail";
import Card from "../components/Card";

import styles from "./login.module.css";
import SignupEmail from "../components/login/SignupEmail";
import LoginTelegram from "../components/login/LoginTelegram";
import PasswordRecovery from "../components/login/PasswordRecovery";
import { loginVariants } from "../routesVariants";
import { useNavigate, useSearchParams } from "react-router";
//import SignupEmailBlocked from "../components/login/SignupEmailBlocked";
import { useTranslation } from "react-i18next";
import {
  getTelegramTargetPath,
  isTelegramLoginRequested,
  clearTelegramLoginSearchParam,
} from "../telegramMiniapp";
import { getToken } from "../utils/tokenStorage";

const setVariantAction = (_, data) => {
  const allowedData = [
    "start",
    "login-email",
    "login-telegram",
    "signup-email",
    "password-recovery",
  ];
  if (allowedData.includes(data)) {
    return data;
  }
  return allowedData[0];
};

function getInitialVariant(searchParams) {
  return isTelegramLoginRequested(searchParams) ? "login-telegram" : "start";
}

export default function Login() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [variant, setVariant] = useActionState(
    setVariantAction,
    getInitialVariant(searchParams)
  );
  const { t, _ } = useTranslation();

  useEffect(() => {
    clearTelegramLoginSearchParam(searchParams, setSearchParams);
  }, []);

  const variants = {
    start: <Start setVariant={(string) => setVariant(string)} />,
    "login-email": <LoginEmail setVariant={(string) => setVariant(string)} />,
    "password-recovery": (
      <PasswordRecovery setVariant={(string) => setVariant(string)} />
    ),
    "signup-email": <SignupEmail setVariant={(string) => setVariant(string)} />,
    "login-telegram": (
      <LoginTelegram setVariant={(string) => setVariant(string)} />
    ),
  };

  useEffect(() => {
    const token = getToken();
    if (token) {
      navigate(getTelegramTargetPath() ?? "/account", { replace: true });
    }
  }, [navigate]);

  return (
    <motion.div
      className={`container container-height-fix column ${styles.wrapper}`}
      variants={loginVariants}
      initial="initial"
      animate="final"
      exit="initial"
    >
      <SpaceBackground expanded={variant !== "start"} />
      <div className={`column ${styles.content}`}>
        <Logo expanded={variant !== "start"} />
        <Card className={`${styles["card"]} ${styles[variant]}`} borders="top">
          <AnimatePresence mode="wait">
            <motion.div
              key={variant}
              layout
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 10, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="wide"
            >
              {variants[variant]}
            </motion.div>
          </AnimatePresence>
          {/*<div className="text-center mb-1">
            {t("When using the service, you agree to")}{" "}
            <a href="/termsandpolicies">{t("the terms and policies")}</a>{" "}
            {t("of the service")}
          </div>*/}
        </Card>
      </div>
    </motion.div>
  );
}
